export default {"src":"/_next/static/media/autoDeployment.1cdfde50.svg","height":24,"width":25};